"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAddSaveFunction;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function getAddSaveFunction() {
  function addSaveFunction() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs;
    function setMaxWidthHeight(p) {
      var width = p.width,
        height = p.height;
      var dimensions = threeJs.dimensions;
      var maxDim = 0;
      Object.keys(dimensions).forEach(function (key) {
        var preConfigDim = dimensions[key];
        if (preConfigDim.width > maxDim) {
          maxDim = preConfigDim.width;
        }
        if (preConfigDim.height > maxDim) {
          maxDim = preConfigDim.height;
        }
      });
      if (!maxDim) {
        maxDim = 8192;
      }
      try {
        var maxRenderBufferSize = threeJs.renderer.getContext().getParameter(threeJs.renderer.getContext().MAX_RENDERBUFFER_SIZE);
        if (maxRenderBufferSize < maxDim) {
          maxDim = maxRenderBufferSize;
        }
      } catch (e) {}
      if (width > maxDim || height > maxDim) {
        if (width >= height) {
          var r = height / width;
          width = maxDim;
          height = width * r;
          if (height % 1) {
            height = Math.floor(height) + 1;
          }
        } else {
          var _r = width / height;
          height = maxDim;
          width = maxDim * _r;
          if (width % 1) {
            width = Math.floor(width) + 1;
          }
        }
      }
      return {
        width: width,
        height: height
      };
    }
    if (threeJs.renderType === "SVG") {
      threeJs.save = /*#__PURE__*/function () {
        var _save = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
          var props,
            _threeJs$post,
            _threeJs$post2,
            _threeJs$post3,
            prepareForServer,
            splitScreen,
            currentComposition,
            selectedDimension,
            _setMaxWidthHeight,
            width,
            height,
            parent,
            _p,
            tempEnableAnimation,
            tempResizeFunction,
            offsetHeight,
            offsetWidth,
            svgRoot,
            background,
            g,
            rectBg,
            colors,
            gradient,
            stop1,
            stop2,
            saveCanvas,
            context,
            backgroundChildren,
            backgroundFullCanvas,
            startY,
            backgroundCanvas,
            imgBg,
            _threeJs$postFilters,
            postFilters,
            na,
            _threeJs$splitScreenD5,
            borderStyle,
            dimFloorHundred,
            lineWidth,
            rect1,
            rect2,
            serializer,
            source,
            fileName,
            blob,
            downloadLink,
            _args2 = arguments;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                props = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                if (threeJs.saveIsProgress) {
                  _context2.next = 120;
                  break;
                }
                prepareForServer = /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          window.dataForServerSaving = {
                            blob: blob,
                            type: "svg",
                            fileName: fileName
                          };
                          console.log("[APP]", "The data for server saving is ready...");
                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function prepareForServer() {
                    return _ref3.apply(this, arguments);
                  };
                }();
                splitScreen = threeJs.splitScreen;
                console.log("[APP]", "Saving...");
                threeJs.saveIsProgress = true;
                _context2.next = 8;
                return threeJs.showProgress({
                  message: "Saving..."
                });
              case 8:
                _context2.next = 10;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 200);
                });
              case 10:
                currentComposition = threeJs.currentComposition;
                selectedDimension = threeJs.dimensions[threeJs.defaultDimension] || threeJs.dimensions[Object.keys(threeJs.dimensions)[0]];
                _setMaxWidthHeight = setMaxWidthHeight({
                  width: props.width || selectedDimension.width,
                  height: props.height || selectedDimension.height
                }), width = _setMaxWidthHeight.width, height = _setMaxWidthHeight.height;
                parent = threeJs.parentContainer;
                _p = {
                  parentWidth: width,
                  parentHeight: height
                }; //const width = parent.offsetWidth
                //const height = parent.offsetHeight
                _context2.next = 17;
                return threeJs.showProgress({
                  message: "Animation stopping..."
                });
              case 17:
                _context2.next = 19;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 19:
                _context2.next = 21;
                return threeJs.animationStop({
                  showControls: false
                });
              case 21:
                tempEnableAnimation = threeJs.enableAnimation;
                threeJs.enableAnimation = false;
                _context2.next = 25;
                return threeJs.showProgress({
                  message: "Canvas resizing..."
                });
              case 25:
                _context2.next = 27;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 27:
                tempResizeFunction = threeJs.onResize;
                threeJs.onResize = function () {};
                offsetHeight = parent.parentElement.offsetHeight;
                offsetWidth = parent.parentElement.offsetWidth;
                parent.parentElement.style.height = offsetHeight + "px";
                parent.parentElement.style.width = offsetWidth + "px";
                parent.style.opacity = 0;
                parent.style.visibility = "hidden";
                parent.style.position = "absolute";
                parent.style.maxHeight = "none";
                parent.style.aspectRatio = "unset";
                parent.style.width = width + "px";
                parent.style.height = height + "px";
                tempResizeFunction();
                _context2.next = 43;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 43:
                _context2.next = 45;
                return threeJs.showProgress({
                  message: "Collecting layers..."
                });
              case 45:
                _context2.next = 47;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 47:
                svgRoot = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svgRoot.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                background = currentComposition.background || "#eeac56";
                svgRoot.setAttribute("style", "background:" + background + "; width:100%; height:100%;");
                svgRoot.setAttribute("width", width);
                svgRoot.setAttribute("height", height);
                svgRoot.setAttribute("viewBox", "-".concat(width / 2, " -").concat(height / 2, " ").concat(width, " ").concat(height));
                g = document.createElementNS("http://www.w3.org/2000/svg", "g");
                g.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                rectBg = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                rectBg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                rectBg.setAttribute("width", "100%");
                rectBg.setAttribute("height", "100%");
                rectBg.setAttribute("transform", "translate(-".concat(width / 2, " -").concat(height / 2, ")"));
                if (background.match("linear-gradient") || background.match("radial-gradient")) {
                  try {
                    colors = background.match(/((rgba?\((.*?)\))|#[a-zA-Z0-9]+)/g);
                    gradient = background.match("linear-gradient") ? document.createElementNS("http://www.w3.org/2000/svg", "linearGradient") : document.createElementNS("http://www.w3.org/2000/svg", "radialGradient");
                    gradient.setAttribute("x1", "0");
                    gradient.setAttribute("y1", "0");
                    gradient.setAttribute("x2", width);
                    gradient.setAttribute("y2", "0");
                    gradient.setAttribute("r", 50 * 1.45 + "%");
                    gradient.setAttribute("id", "bg-gradient");
                    stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
                    stop1.setAttribute("style", "stop-color:" + colors[0]);
                    stop1.setAttribute("stop-color", colors[0]);
                    stop1.setAttribute("offset", "0%");
                    stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
                    stop2.setAttribute("style", "stop-color:" + colors[1]);
                    stop2.setAttribute("stop-color", colors[0]);
                    stop2.setAttribute("offset", "100%");
                    gradient.appendChild(stop1);
                    gradient.appendChild(stop2);
                    g.appendChild(gradient);
                    rectBg.setAttribute("style", "fill: url(#bg-gradient)");
                  } catch (e) {
                    rectBg.setAttribute("style", "fill: " + background);
                    console.log(e);
                  }
                } else {
                  rectBg.setAttribute("style", "fill: " + background);
                }
                g.appendChild(rectBg);
                svgRoot.appendChild(g);
                saveCanvas = document.createElement("canvas");
                saveCanvas.setAttribute("width", width);
                saveCanvas.setAttribute("height", height);
                context = saveCanvas.getContext("2d");
                if (splitScreen) {
                  backgroundChildren = (0, _toConsumableArray2["default"])(threeJs.canvasBackgroundContainer.children);
                  backgroundChildren.map(function (canvas, i) {
                    var n = i === 1 ? 0 : i;
                    var _ref = i === 0 ? {
                        visibility: "visible"
                      } : threeJs.getVisibility(n),
                      visibility = _ref.visibility;
                    if (visibility === "hidden") {
                      return;
                    }
                    var _ref2 = i === 0 ? {
                        left: 0,
                        top: 0
                      } : threeJs.getLeftAndTop(n, _p),
                      left = _ref2.left,
                      top = _ref2.top;
                    var childDim = i === 0 ? {
                      width: 0,
                      height: 0
                    } : threeJs.getWidthAndHeight(n, _p);
                    var x = left * width / 100 - childDim.width / 2;
                    var y = top * height / 100 - childDim.height / 2;
                    context.drawImage(canvas, x, y);
                  });
                } else {
                  backgroundFullCanvas = threeJs.canvasBackgroundContainer.children[0];
                  context.drawImage(backgroundFullCanvas, 0, 0);
                  startY = width / height < 1 ? (height - width) / 2 : 0;
                  backgroundCanvas = threeJs.canvasBackgroundContainer.children[1];
                  context.drawImage(backgroundCanvas, 0, startY);
                }
                imgBg = document.createElementNS("http://www.w3.org/2000/svg", "image");
                imgBg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                imgBg.setAttribute("xlink:href", "".concat(saveCanvas.toDataURL()));
                imgBg.setAttribute("width", "100%");
                imgBg.setAttribute("height", "100%");
                imgBg.setAttribute("transform", "translate(-".concat(width / 2, " -").concat(height / 2, ")"));
                g.appendChild(imgBg);
                _threeJs$postFilters = threeJs.postFilters, postFilters = _threeJs$postFilters === void 0 ? [] : _threeJs$postFilters;
                na = splitScreen ? [2, 3, 4, 0] : [0];
                na.forEach(function (n) {
                  var rendererPropName = n ? "renderer" + n : "renderer";
                  if (threeJs[rendererPropName]) {
                    var _threeJs$splitScreenD, _threeJs$splitScreenD2, _threeJs$splitScreenD3, _threeJs$splitScreenD4;
                    var _threeJs$getVisibilit = threeJs.getVisibility(n),
                      visibility = _threeJs$getVisibilit.visibility;
                    if (visibility === "hidden") {
                      return;
                    }
                    var svgRenderer = threeJs[rendererPropName].domElement;
                    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                    svg.setAttribute("viewBox", svgRenderer.getAttribute("viewBox"));
                    var svgDim = threeJs.getWidthAndHeight(n, _p);
                    svg.setAttribute("width", svgDim.width);
                    svg.setAttribute("height", svgDim.height);
                    svg.innerHTML = svgRenderer.innerHTML;
                    var _g = document.createElementNS("http://www.w3.org/2000/svg", "g");
                    _g.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                    var filter = document.createElementNS("http://www.w3.org/2000/svg", "filter");
                    filter.setAttribute("id", "filter-" + n);
                    var splitScreenCustomPostFilters = (splitScreen || n > 0) && (_threeJs$splitScreenD = threeJs.splitScreenData) !== null && _threeJs$splitScreenD !== void 0 && _threeJs$splitScreenD.renderersData && (_threeJs$splitScreenD2 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD2 !== void 0 && _threeJs$splitScreenD2.renderersData["" + n] && (_threeJs$splitScreenD3 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD3 !== void 0 && _threeJs$splitScreenD3.renderersData["" + n].postFilters ? (_threeJs$splitScreenD4 = threeJs.splitScreenData) === null || _threeJs$splitScreenD4 === void 0 ? void 0 : _threeJs$splitScreenD4.renderersData["" + n].postFilters : null;
                    var createFilters = {
                      grayscale: function grayscale(value) {
                        var amount = 1 - Math.max(1, Math.min(0, value));
                        var values = [0.2126 + 0.7874 * amount, 0.7152 - 0.7152 * amount, 0.0722 - 0.0722 * amount, 0, 0, 0.2126 - 0.2126 * amount, 0.7152 + 0.2848 * amount, 0.0722 - 0.0722 * amount, 0, 0, 0.2126 - 0.2126 * amount, 0.7152 - 0.7152 * amount, 0.0722 + 0.9278 * amount, 0, 0, 0, 0, 0, 1, 0].join(" ");
                        var e = document.createElementNS("http://www.w3.org/2000/svg", "feColorMatrix");
                        e.setAttribute("type", "matrix");
                        e.setAttribute("color-interpolation-filters", "sRGB");
                        e.setAttribute("values", values);
                        filter.appendChild(e);
                      }
                    };
                    if (splitScreen && splitScreenCustomPostFilters) {
                      splitScreenCustomPostFilters.forEach(function (postFilter) {
                        if (createFilters[postFilter.type]) {
                          createFilters[postFilter.type](postFilter.value);
                        }
                      });
                    }
                    if (!splitScreen && postFilters) {
                      postFilters.forEach(function (postFilter) {
                        if (createFilters[postFilter.type]) {
                          createFilters[postFilter.type](postFilter.value);
                        }
                      });
                    }
                    if (filter.children.length) {
                      svgRoot.appendChild(filter);
                      svg.setAttribute("filter", "url(#filter-" + n + ")");
                    }
                    if (splitScreen) {
                      var _threeJs$getLeftAndTo = threeJs.getLeftAndTop(n, _p),
                        left = _threeJs$getLeftAndTo.left,
                        top = _threeJs$getLeftAndTo.top;
                      var x = left * width / 100 - svgDim.width / 2 - width / 2;
                      var y = top * height / 100 - svgDim.height / 2 - height / 2;
                      svg.setAttribute("x", x);
                      svg.setAttribute("y", y);
                    } else {
                      var _startY = width / height < 1 ? (height - width) / 2 : 0;
                      _g.setAttribute("transform", "translate(-".concat(width / 2, " ").concat(-height / 2 + _startY, ")"));
                    }
                    svgRoot.appendChild(_g);
                    _g.appendChild(svg);
                  }
                });
                if (splitScreen) {
                  borderStyle = splitScreen && (_threeJs$splitScreenD5 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD5 !== void 0 && _threeJs$splitScreenD5.hideBorders ? "none" : "";
                  if (borderStyle !== "none") {
                    dimFloorHundred = Math.max(600, Math.min(Math.floor(width / 100) * 100, Math.floor(height / 100) * 100));
                    lineWidth = Math.floor(dimFloorHundred / 600 * 10) / 10;
                    rect1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                    rect1.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                    rect1.setAttribute("width", "100%");
                    rect1.setAttribute("height", lineWidth);
                    rect1.setAttribute("style", "fill: rgba(0,0,0,0.2);");
                    rect1.setAttribute("transform", "translate(-".concat(width / 2, " 0)"));
                    rect2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                    rect2.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                    rect2.setAttribute("width", lineWidth);
                    rect2.setAttribute("height", "100%");
                    rect2.setAttribute("style", "fill: rgba(0,0,0,0.2);");
                    rect2.setAttribute("transform", "translate(0 -".concat(height / 2, ")"));
                    svgRoot.appendChild(rect1);
                    svgRoot.appendChild(rect2);
                  }
                }
                _context2.next = 82;
                return threeJs.showProgress({
                  message: "Collecting file..."
                });
              case 82:
                _context2.next = 84;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 84:
                serializer = new XMLSerializer();
                source = serializer.serializeToString(svgRoot);
                if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
                  source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
                }
                if (!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)) {
                  source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
                }
                fileName = ["c4rc0", ((_threeJs$post = threeJs.post) === null || _threeJs$post === void 0 ? void 0 : _threeJs$post.slug) || ((_threeJs$post2 = threeJs.post) === null || _threeJs$post2 === void 0 ? void 0 : _threeJs$post2._id) || "", threeJs.isGenerated && (_threeJs$post3 = threeJs.post) !== null && _threeJs$post3 !== void 0 && _threeJs$post3.hash && threeJs.post.hash !== threeJs.post.slug ? threeJs.post.hash : "", "composition", threeJs.compositionIndex, splitScreen ? "splitscreen" : "", width + "x" + height].filter(function (t) {
                  return t || t === 0;
                }).join("_");
                blob = new Blob([source], {
                  type: "image/svg+xml;charset=utf-8"
                });
                downloadLink = document.createElement("a");
                downloadLink.download = fileName + ".svg";
                downloadLink.href = URL.createObjectURL(blob);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                parent.style.maxHeight = "";
                parent.style.width = "";
                parent.style.height = "";
                parent.style.visibility = "";
                parent.style.position = "";
                parent.style.aspectRatio = "";
                parent.parentElement.style.height = "";
                parent.parentElement.style.width = "";
                _context2.next = 106;
                return threeJs.showProgress({
                  message: "Canvas resizing..."
                });
              case 106:
                _context2.next = 108;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 108:
                tempResizeFunction();
                parent.style.opacity = "";
                _context2.next = 112;
                return threeJs.showProgress({
                  message: "Animation starting..."
                });
              case 112:
                _context2.next = 114;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 114:
                if (tempEnableAnimation) {
                  threeJs.enableAnimation = true;
                }
                if (threeJs.render) {
                  threeJs.render();
                }
                threeJs.onResize = tempResizeFunction;
                threeJs.hideProgress();
                threeJs.saveIsProgress = false;
                prepareForServer();
              case 120:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function save() {
          return _save.apply(this, arguments);
        }
        return save;
      }();
    } else {
      threeJs.save = /*#__PURE__*/function () {
        var _save2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
          var props,
            _threeJs$post4,
            _threeJs$post5,
            _threeJs$post6,
            splitScreen,
            currentComposition,
            selectedDimension,
            _setMaxWidthHeight2,
            width,
            height,
            parent,
            tempEnableAnimation,
            tempResizeFunction,
            offsetHeight,
            offsetWidth,
            saveCanvas,
            context,
            bgString,
            colors,
            gradient,
            _colors,
            tempCanvas,
            tctx,
            shittX,
            shittY,
            _gradient,
            scaleX,
            scaleY,
            _threeJs$postFilters2,
            postFilters,
            filterString,
            _threeJs$composer,
            _threeJs$composer$ren,
            _threeJs$composer2,
            _threeJs$composer3,
            _threeJs$composer3$re,
            _threeJs$splitScreenD10,
            backgroundChildren,
            effectChildren,
            rendererOpacity,
            blendMode,
            na,
            borderStyle,
            containerHeight,
            startY,
            endY,
            dimFloorHundred,
            lineWidth,
            _threeJs$composer4,
            _threeJs$composer4$re,
            _threeJs$composer5,
            _threeJs$composer6,
            _threeJs$composer6$re,
            backgroundFullCanvas,
            backgroundCanvas,
            effect,
            renderer,
            _rendererOpacity,
            _blendMode,
            _startY2,
            fileName,
            downloadLink,
            _args5 = arguments;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                props = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                if (threeJs.saveIsProgress) {
                  _context5.next = 68;
                  break;
                }
                splitScreen = threeJs.splitScreen;
                console.log("[APP]", "Saving...");
                threeJs.saveIsProgress = true;
                _context5.next = 7;
                return threeJs.showProgress({
                  message: "Saving..."
                });
              case 7:
                _context5.next = 9;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 200);
                });
              case 9:
                currentComposition = threeJs.currentComposition;
                selectedDimension = threeJs.dimensions[threeJs.defaultDimension] || threeJs.dimensions[Object.keys(threeJs.dimensions)[0]];
                _setMaxWidthHeight2 = setMaxWidthHeight({
                  width: props.width || selectedDimension.width,
                  height: props.height || selectedDimension.height
                }), width = _setMaxWidthHeight2.width, height = _setMaxWidthHeight2.height;
                parent = threeJs.parentContainer; //const width = parent.offsetWidth
                //const height = parent.offsetHeight
                _context5.next = 15;
                return threeJs.showProgress({
                  message: "Animation stopping..."
                });
              case 15:
                _context5.next = 17;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 17:
                _context5.next = 19;
                return threeJs.animationStop({
                  showControls: false
                });
              case 19:
                tempEnableAnimation = threeJs.enableAnimation;
                threeJs.enableAnimation = false;
                _context5.next = 23;
                return threeJs.showProgress({
                  message: "Canvas resizing..."
                });
              case 23:
                _context5.next = 25;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 25:
                tempResizeFunction = threeJs.onResize;
                threeJs.onResize = function () {};
                offsetHeight = parent.parentElement.offsetHeight;
                offsetWidth = parent.parentElement.offsetWidth;
                parent.parentElement.style.height = offsetHeight + "px";
                parent.parentElement.style.width = offsetWidth + "px";
                parent.style.opacity = 0;
                parent.style.visibility = "hidden";
                parent.style.position = "absolute";
                parent.style.maxHeight = "none";
                parent.style.aspectRatio = "unset";
                parent.style.width = width + "px";
                parent.style.height = height + "px";
                _context5.next = 40;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 40:
                tempResizeFunction();
                _context5.next = 43;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 43:
                _context5.next = 45;
                return threeJs.showProgress({
                  message: "Collecting layers..."
                });
              case 45:
                _context5.next = 47;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 47:
                saveCanvas = document.createElement("canvas");
                saveCanvas.setAttribute("width", width);
                saveCanvas.setAttribute("height", height);
                context = saveCanvas.getContext("2d");
                bgString = currentComposition.background || "#eeac56";
                context.fillStyle = bgString;
                if (bgString.match("linear-gradient")) {
                  try {
                    colors = bgString.match(/((rgba?\((.*?)\))|#[a-zA-Z0-9]+)/g);
                    gradient = context.createLinearGradient(0, 0, 0, height);
                    gradient.addColorStop(0, colors[0]);
                    gradient.addColorStop(1, colors[1]);
                    context.fillStyle = gradient;
                  } catch (e) {
                    context.fillStyle = bgString;
                    console.log(e);
                  }
                }
                context.fillRect(0, 0, width, height);
                context.fillStyle = "#000000";
                if (bgString.match("radial-gradient")) {
                  try {
                    _colors = bgString.match(/((rgba?\((.*?)\))|#[a-zA-Z0-9]+)/g);
                    tempCanvas = document.createElement("canvas");
                    tempCanvas.setAttribute("width", width);
                    tempCanvas.setAttribute("height", height);
                    tctx = tempCanvas.getContext("2d");
                    shittX = Math.max(width, height) / 2;
                    shittY = Math.max(width, height) / 2;
                    _gradient = tctx.createRadialGradient(width / 2 + shittX, height / 2 + shittY, 1, width / 2 + shittX, height / 2 + shittY, Math.max(width / 2, height / 2) * 1.45);
                    _gradient.addColorStop(0, _colors[0]);
                    _gradient.addColorStop(1, _colors[1]);
                    scaleX = height > width ? width / height : 1;
                    scaleY = width > height ? height / width : 1;
                    tctx.scale(scaleX, scaleY);
                    tctx.translate(-shittX * scaleX, -shittY * scaleY);
                    tctx.fillStyle = _gradient;
                    tctx.fillRect(width / 2, height / 2, Math.max(width, height), Math.max(width, height));
                    tctx.setTransform(1, 0, 0, 1, 0, 0);
                    context.drawImage(tempCanvas, 0, 0);
                  } catch (e) {
                    context.fillStyle = bgString;
                    context.fillRect(0, 0, width, height);
                    context.fillStyle = "#000000";
                    console.log(e);
                  }
                }
                _threeJs$postFilters2 = threeJs.postFilters, postFilters = _threeJs$postFilters2 === void 0 ? [] : _threeJs$postFilters2;
                filterString = postFilters && postFilters.map(function (postFilter) {
                  return postFilter.type + "(" + postFilter.value + ")";
                }).join(" ") || "";
                if (splitScreen) {
                  backgroundChildren = (0, _toConsumableArray2["default"])(threeJs.canvasBackgroundContainer.children);
                  backgroundChildren.map(function (canvas, i) {
                    var n = i === 1 ? 0 : i;
                    var _ref4 = i === 0 ? {
                        visibility: "visible"
                      } : threeJs.getVisibility(n),
                      visibility = _ref4.visibility;
                    if (visibility === "hidden") {
                      return;
                    }
                    var _ref5 = i === 0 ? {
                        left: 0,
                        top: 0
                      } : threeJs.getLeftAndTop(n, p),
                      left = _ref5.left,
                      top = _ref5.top;
                    var childDim = i === 0 ? {
                      width: 0,
                      height: 0
                    } : threeJs.getWidthAndHeight(n, p);
                    var x = left * width / 100 - childDim.width / 2;
                    var y = top * height / 100 - childDim.height / 2;
                    context.drawImage(canvas, x, y);
                  });
                  effectChildren = (0, _toConsumableArray2["default"])(threeJs.effectsContainer.children);
                  rendererOpacity = typeof ((_threeJs$composer = threeJs.composer) === null || _threeJs$composer === void 0 ? void 0 : (_threeJs$composer$ren = _threeJs$composer.renderer) === null || _threeJs$composer$ren === void 0 ? void 0 : _threeJs$composer$ren.opacity) === "number" ? threeJs.composer.renderer.opacity : 1;
                  blendMode = (_threeJs$composer2 = threeJs.composer) !== null && _threeJs$composer2 !== void 0 && _threeJs$composer2.enable && typeof ((_threeJs$composer3 = threeJs.composer) === null || _threeJs$composer3 === void 0 ? void 0 : (_threeJs$composer3$re = _threeJs$composer3.renderer) === null || _threeJs$composer3$re === void 0 ? void 0 : _threeJs$composer3$re.blendMode) === "string" ? threeJs.composer.renderer.blendMode : "";
                  na = [2, 3, 4, 0];
                  na.forEach(function (n) {
                    var rendererPropName = n ? "renderer" + n : "renderer";
                    if (threeJs[rendererPropName]) {
                      var _threeJs$splitScreenD6, _threeJs$splitScreenD7, _threeJs$splitScreenD8, _threeJs$splitScreenD9;
                      var _threeJs$getVisibilit2 = threeJs.getVisibility(n),
                        visibility = _threeJs$getVisibilit2.visibility;
                      if (visibility === "hidden") {
                        return;
                      }
                      var splitScreenCustomPostFilters = (splitScreen || n > 0) && (_threeJs$splitScreenD6 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD6 !== void 0 && _threeJs$splitScreenD6.renderersData && (_threeJs$splitScreenD7 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD7 !== void 0 && _threeJs$splitScreenD7.renderersData["" + n] && (_threeJs$splitScreenD8 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD8 !== void 0 && _threeJs$splitScreenD8.renderersData["" + n].postFilters ? (_threeJs$splitScreenD9 = threeJs.splitScreenData) === null || _threeJs$splitScreenD9 === void 0 ? void 0 : _threeJs$splitScreenD9.renderersData["" + n].postFilters : null;
                      var splitScreenCustomPostFilterString = splitScreenCustomPostFilters && splitScreenCustomPostFilters.map(function (postFilter) {
                        return postFilter.type + "(" + postFilter.value + ")";
                      }).join(" ") || "";
                      var fS = !splitScreen ? filterString : splitScreenCustomPostFilterString;
                      var _threeJs$getLeftAndTo2 = threeJs.getLeftAndTop(n),
                        left = _threeJs$getLeftAndTo2.left,
                        top = _threeJs$getLeftAndTo2.top;
                      var childDim = threeJs.getWidthAndHeight(n);
                      var x = left * width / 100 - childDim.width / 2;
                      var y = top * height / 100 - childDim.height / 2;
                      var effectCanvas = effectChildren[!n ? n : n - 1];
                      if (effectCanvas) {
                        if (fS) {
                          context.filter = fS;
                        }
                        context.drawImage(effectCanvas, x, y);
                        context.filter = "none";
                      }
                      if (blendMode) {
                        context.globalCompositeOperation = blendMode;
                      }
                      context.globalAlpha = rendererOpacity;
                      var canvas = threeJs[rendererPropName].domElement;
                      if (canvas) {
                        if (fS) {
                          context.filter = fS;
                        }
                        context.drawImage(canvas, x, y);
                        context.filter = "none";
                      }
                      context.globalAlpha = 1;
                      context.globalCompositeOperation = "source-over";
                    }
                  });
                  context.globalAlpha = 1;
                  context.globalCompositeOperation = "source-over";
                  borderStyle = splitScreen && (_threeJs$splitScreenD10 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD10 !== void 0 && _threeJs$splitScreenD10.hideBorders ? "none" : "";
                  if (borderStyle !== "none") {
                    containerHeight = height > width ? width : height;
                    startY = containerHeight !== height ? (height - containerHeight) / 2 : 0;
                    endY = containerHeight !== height ? startY + containerHeight : height;
                    dimFloorHundred = Math.max(600, Math.min(Math.floor(width / 100) * 100, Math.floor(height / 100) * 100));
                    lineWidth = Math.floor(dimFloorHundred / 600 * 10) / 10;
                    context.beginPath();
                    context.lineWidth = lineWidth;
                    context.strokeStyle = "rgba(0,0,0,0.2)";
                    context.moveTo(width / 2, startY);
                    context.lineTo(width / 2, endY);
                    context.stroke();
                    context.beginPath();
                    context.lineWidth = lineWidth;
                    context.strokeStyle = "rgba(0,0,0,0.2)";
                    context.moveTo(0, height / 2);
                    context.lineTo(width, height / 2);
                    context.stroke();
                  }
                } else {
                  backgroundFullCanvas = threeJs.canvasBackgroundContainer.children[0];
                  backgroundCanvas = threeJs.canvasBackgroundContainer.children[1];
                  effect = threeJs.effectsContainer.firstChild;
                  renderer = threeJs.renderer.domElement;
                  _rendererOpacity = typeof ((_threeJs$composer4 = threeJs.composer) === null || _threeJs$composer4 === void 0 ? void 0 : (_threeJs$composer4$re = _threeJs$composer4.renderer) === null || _threeJs$composer4$re === void 0 ? void 0 : _threeJs$composer4$re.opacity) === "number" ? threeJs.composer.renderer.opacity : 1;
                  _blendMode = (_threeJs$composer5 = threeJs.composer) !== null && _threeJs$composer5 !== void 0 && _threeJs$composer5.enable && typeof ((_threeJs$composer6 = threeJs.composer) === null || _threeJs$composer6 === void 0 ? void 0 : (_threeJs$composer6$re = _threeJs$composer6.renderer) === null || _threeJs$composer6$re === void 0 ? void 0 : _threeJs$composer6$re.blendMode) === "string" ? threeJs.composer.renderer.blendMode : "";
                  _startY2 = width / height < 1 ? (height - width) / 2 : 0;
                  context.drawImage(backgroundFullCanvas, 0, 0);
                  context.drawImage(backgroundCanvas, 0, _startY2);
                  if (filterString) {
                    context.filter = filterString;
                  }
                  context.drawImage(effect, 0, _startY2);
                  context.filter = "none";
                  if (_blendMode) {
                    context.globalCompositeOperation = _blendMode;
                  }
                  context.globalAlpha = _rendererOpacity;
                  if (filterString) {
                    context.filter = filterString;
                  }
                  context.drawImage(renderer, 0, _startY2);
                  context.filter = "none";
                }
                _context5.next = 62;
                return threeJs.showProgress({
                  message: "Collecting file..."
                });
              case 62:
                _context5.next = 64;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 64:
                fileName = ["c4rc0", ((_threeJs$post4 = threeJs.post) === null || _threeJs$post4 === void 0 ? void 0 : _threeJs$post4.slug) || ((_threeJs$post5 = threeJs.post) === null || _threeJs$post5 === void 0 ? void 0 : _threeJs$post5._id) || "", threeJs.isGenerated && (_threeJs$post6 = threeJs.post) !== null && _threeJs$post6 !== void 0 && _threeJs$post6.hash && threeJs.post.hash !== threeJs.post.slug ? threeJs.post.hash : "", "composition", threeJs.compositionIndex, splitScreen ? "splitscreen" : "", width + "x" + height].filter(function (t) {
                  return t || t === 0;
                }).join("_");
                downloadLink = document.createElement("a");
                downloadLink.download = fileName + ".png";
                saveCanvas.toBlob( /*#__PURE__*/function () {
                  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(blob) {
                    var prepareForServer, _prepareForServer;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _prepareForServer = function _prepareForServer3() {
                            _prepareForServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
                              return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                                while (1) switch (_context3.prev = _context3.next) {
                                  case 0:
                                    window.dataForServerSaving = {
                                      blob: blob,
                                      type: "png",
                                      fileName: fileName
                                    };
                                    console.log("[APP]", "The data for server saving is ready...");
                                  case 2:
                                  case "end":
                                    return _context3.stop();
                                }
                              }, _callee3);
                            }));
                            return _prepareForServer.apply(this, arguments);
                          };
                          prepareForServer = function _prepareForServer2() {
                            return _prepareForServer.apply(this, arguments);
                          };
                          downloadLink.href = URL.createObjectURL(blob);
                          document.body.appendChild(downloadLink);
                          downloadLink.click();
                          document.body.removeChild(downloadLink);
                          parent.style.maxHeight = "";
                          parent.style.width = "";
                          parent.style.height = "";
                          parent.style.visibility = "";
                          parent.style.position = "";
                          parent.style.aspectRatio = "";
                          parent.parentElement.style.height = "";
                          parent.parentElement.style.width = "";
                          _context4.next = 16;
                          return threeJs.showProgress({
                            message: "Canvas resizing..."
                          });
                        case 16:
                          _context4.next = 18;
                          return new Promise(function (resolve) {
                            return setTimeout(resolve, 100);
                          });
                        case 18:
                          tempResizeFunction();
                          parent.style.opacity = "";
                          _context4.next = 22;
                          return threeJs.showProgress({
                            message: "Animation starting..."
                          });
                        case 22:
                          _context4.next = 24;
                          return new Promise(function (resolve) {
                            return setTimeout(resolve, 100);
                          });
                        case 24:
                          if (tempEnableAnimation) {
                            threeJs.enableAnimation = true;
                          }
                          if (threeJs.render) {
                            threeJs.render();
                          }
                          threeJs.onResize = tempResizeFunction;
                          threeJs.hideProgress();
                          threeJs.saveIsProgress = false;
                          prepareForServer();
                        case 30:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x) {
                    return _ref6.apply(this, arguments);
                  };
                }());
              case 68:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function save() {
          return _save2.apply(this, arguments);
        }
        return save;
      }();
    }
  }
  return {
    addSaveFunction: addSaveFunction
  };
}